import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { EmployeeTeamAdapter } from "./employee-team.adapter";
import { EmployeeTeamController } from "./employee-team.controller";
import { EmployeeTeamService } from "./employee-team.service";
import { EmployeeTeamEntity } from "./entity/employee-team.entity";

@Module({
    imports: [
      TypeOrmModule.forFeature([EmployeeTeamEntity]),
    ],
    controllers: [EmployeeTeamController],
    providers: [EmployeeTeamService, EmployeeTeamAdapter, ApplicationExceptionHandler],
    exports: [EmployeeTeamService]
  })
  export class EmployeeTeamModule {}